var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtTab2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0647 21.6952L11.1834 17.5795C12.9954 16.9562 14.692 16.118 16.2616 15.1401L13.0647 21.6952ZM4.42029 11.2824L0 9.53076L7.04014 6.55414C5.98989 8.01559 5.08968 9.59524 4.42029 11.2824ZM22.8516 0.418208C22.8516 0.418208 17.1387 -1.86101 10.6064 4.22227C8.07885 6.57563 6.56696 9.1654 5.58595 11.4328C5.2628 12.2387 5.48208 13.1199 6.11685 13.7217L8.57513 15.9998C9.20989 16.6016 10.1563 16.795 11.0219 16.4941C13.9286 15.4622 16.5678 13.8691 18.766 11.8196C25.2984 5.73745 22.8516 0.418208 22.8516 0.418208ZM14.692 8.01559C13.7918 7.1774 13.7918 5.81267 14.692 4.97449C15.5922 4.1363 17.0579 4.1363 17.9581 4.97449C18.8468 5.81267 18.8584 7.1774 17.9581 8.01559C17.0579 8.85377 15.5922 8.85377 14.692 8.01559ZM5.11276 21.491L9.31377 17.5795C8.92136 17.4828 8.5405 17.3216 8.19427 17.0959L3.48545 21.491H5.11276ZM0.219283 21.491H1.8466L7.35176 16.3759L5.7129 14.8608L0.219283 19.9758V21.491ZM0.219283 18.4499L4.93964 14.0656C4.69728 13.7432 4.52416 13.3993 4.42029 13.0232L0.219283 16.9347V18.4499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtTab2);
export default __webpack_public_path__ + "static/media/bt_tab_2.ece7da9cdd9a214d192684b34599ea63.svg";
export { ForwardRef as ReactComponent };